import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const user = await login(username, password);
      if (!user) {
        setError('Erreur lors de la connexion: utilisateur non reçu');
        return;
      }
      if (user.role === 'admin' || user.role === 'super_admin') {
        navigate('/dashboard');
      } else if (user.role === 'hotesse') {
        navigate('/hostess');
      } else {
        navigate('/home');
      }
    } catch (err) {
      setError(err.message || 'Erreur lors de la connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f4f6f9',
      padding: '20px',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Cercles décoratifs */}
      <div style={{ position: 'absolute', top: '60px', left: '40px', width: '80px', height: '80px', borderRadius: '50%', background: 'rgba(255,255,255,0.1)', backdropFilter: 'blur(4px)' }}></div>
      <div style={{ position: 'absolute', top: '160px', left: '100px', width: '40px', height: '40px', borderRadius: '50%', background: 'rgba(255,255,255,0.08)' }}></div>
      <div style={{ position: 'absolute', top: '80px', right: '60px', width: '60px', height: '60px', borderRadius: '50%', background: 'rgba(255,255,255,0.1)' }}></div>
      <div style={{ position: 'absolute', top: '180px', right: '120px', width: '30px', height: '30px', borderRadius: '50%', background: 'rgba(255,255,255,0.07)' }}></div>

      {/* Bande décorative bas */}
      <div style={{
        position: 'absolute',
        bottom: '0',
        left: '0',
        right: '0',
        height: '8px',
        background: 'linear-gradient(90deg, #0d47a1 0%, #1565c0 50%, #1976d2 100%)'
      }}></div>

      <div style={{
        maxWidth: '450px',
        width: '100%',
        background: '#ffffff',
        borderRadius: '20px',
        padding: '40px',
        boxShadow: '0 25px 70px rgba(0, 0, 0, 0.3)',
        border: '3px solid #1565c0',
        position: 'relative',
        zIndex: '1'
      }}>
        {/* Bande couleur haut */}
        <div style={{
          position: 'absolute',
          top: '0',
          left: '0',
          right: '0',
          height: '6px',
          background: 'linear-gradient(90deg, #0d47a1 0%, #1976d2 50%, #42a5f5 100%)',
          borderRadius: '17px 17px 0 0'
        }}></div>

        {/* Logo Supermont */}
        <div style={{ textAlign: 'center', marginBottom: '30px', marginTop: '15px' }}>
          <div style={{
            width: '100px',
            height: '100px',
            borderRadius: '50%',
            background: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 15px',
            boxShadow: '0 6px 20px rgba(21, 101, 192, 0.4)',
            overflow: 'hidden',
            padding: '4px'
          }}>
            <img src="/images/logo-supermont.png" alt="Supermont" style={{ width: "100%", height: "100%", objectFit: "contain", borderRadius: "50%" }} />
          </div>
          <h2 style={{
            color: '#0d47a1',
            fontWeight: 'bold',
            margin: '10px 0 4px',
            fontSize: '26px',
            letterSpacing: '1px',
            fontFamily: 'Nunito, sans-serif'
          }}>
            Les Perles de Vie
          </h2>
          <p style={{
            color: '#1976d2',
            fontWeight: '600',
            margin: '0',
            fontSize: '14px',
            letterSpacing: '2px',
            textTransform: 'uppercase'
          }}>
            Supermont
          </p>
        </div>

        {error && (
          <div className="alert alert-danger mb-3" role="alert" style={{
            background: '#e3f2fd',
            border: '2px solid #1565c0',
            color: '#0d47a1',
            borderRadius: '10px'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label" style={{
              color: '#0d47a1',
              fontWeight: 'bold',
              textTransform: 'uppercase',
              fontSize: '12px',
              letterSpacing: '1px'
            }}>
              Nom d'utilisateur
            </label>
            <input
              type="text"
              className="form-control"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
              style={{
                borderRadius: '10px',
                padding: '12px',
                border: '2px solid #1565c0',
                fontSize: '16px',
                background: '#f5f9ff'
              }}
            />
          </div>
          <div className="mb-4">
            <label className="form-label" style={{
              color: '#0d47a1',
              fontWeight: 'bold',
              textTransform: 'uppercase',
              fontSize: '12px',
              letterSpacing: '1px'
            }}>
              Mot de passe
            </label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                borderRadius: '10px',
                padding: '12px',
                border: '2px solid #1565c0',
                fontSize: '16px',
                background: '#f5f9ff'
              }}
            />
          </div>
          <button
            type="submit"
            className="btn btn-primary w-100"
            disabled={loading}
            style={{
              background: 'linear-gradient(180deg, #1976d2 0%, #1565c0 50%, #0d47a1 100%)',
              border: 'none',
              borderRadius: '15px',
              padding: '15px',
              fontSize: '18px',
              fontWeight: 'bold',
              textTransform: 'uppercase',
              letterSpacing: '2px',
              color: '#ffffff',
              boxShadow: '0 8px 25px rgba(21, 101, 192, 0.4)'
            }}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2"></span>
                Connexion...
              </>
            ) : 'Se connecter'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: '25px' }}>
          <small style={{ color: '#1565c0', fontWeight: 'bold', fontSize: '12px' }}>
            &copy; 2026 SUPERMONT &mdash; Les Perles de Vie
          </small>
        </div>
      </div>
    </div>
  );
};

export default Login;
